var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarehouseHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.676 7.882-11.25-7.75c-.256-.176-.594-.176-.851 0l-11.25 7.75c-.204.14-.325.371-.325.618v14.5c0 .552.448 1 1 1h2v-12c0-.552.448-1 1-1h16c.552 0 1 .448 1 1v12h2c.552 0 1-.448 1-1v-14.5c0-.247-.121-.478-.324-.618z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.25 19v.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-.75h-1.75c-.276 0-.5.224-.5.5v4c0 .276.224.5.5.5h5c.276 0 .5-.224.5-.5v-4c0-.276-.224-.5-.5-.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.25 19v.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-.75h-1.75c-.276 0-.5.224-.5.5v4c0 .276.224.5.5.5h5c.276 0 .5-.224.5-.5v-4c0-.276-.224-.5-.5-.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12.75 13v.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-.75h-1.75c-.276 0-.5.224-.5.5v4c0 .276.224.5.5.5h5c.276 0 .5-.224.5-.5v-4c0-.276-.224-.5-.5-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseHub);
export default __webpack_public_path__ + "static/media/WarehouseHub.dd24869c76ec80c95295009844f72714.svg";
export { ForwardRef as ReactComponent };